module.exports = "<li class=rp-raceResult__horse data-ng-repeat=\"item in fastInfo\" data-outcome-desc=\"{{ item['outcome_code'] }}\"> <span class=rp-raceResult__horseName data-test-selector=\"text-horse-name-awaiting-{{ item['race_id']}}\"> {{item['saddle_cloth']}}. {{ item['horse_name']}} </span><span class=rp-raceResult__horsePrice data-ng-bind=\"item['price']\"></span> </li> <li class=rp-raceResult__horse_wait data-ng-show=fastResultsAvailable data-test-selector=text-awaiting data-test-view=list-results> Awaiting full result... </li>";


//////////////////
// WEBPACK FOOTER
// ./public/views/fastResults.html
// module id = 1495
// module chunks = 1